export default __webpack_public_path__ + "static/media/icon-laser-engraving.47ab3d7a.svg";